<template>
  <div class="index-title">
    <span :class="['index-title__index', `title-${type}`]">{{ index }}</span>
    <Heading
      :text="text"
      :shuffle="shuffle"
      loop
      spaced
      :type="type"
      class="index-title__title"
    ></Heading>
    <p class="index-title__caption" v-if="caption">{{ caption }}</p>
  </div>
</template>

<script>
import Heading from "@/components/Heading";
export default {
  name: "IndexTitle",
  components: {
    Heading,
  },
  props: {
    text: String,
    index: String,
    caption: String,
    type: {
      type: String,
      default: "h3",
    },
    shuffle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
